import React, { Children, cloneElement } from 'react';

import { arrayOf, bool, func, shape, string } from 'prop-types';

import BaseComponent from '../.internal/BaseComponent';

import './RadioButtonGroup.scss';

import Label from '../label/Label';
import RadioButton from '../radio_button/RadioButton';

export default class RadioButtonGroup extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { value: props.defaultValue };
  }

  handleChildrenChange = (checked, childrenValue) => {
    const { value, onChange } = this.props;
    if (typeof value === 'undefined') {
      this.setState({
        value: childrenValue
      });
    }
    if (typeof onChange !== 'undefined') {
      onChange(childrenValue);
    }
  };

  childrenChecked = childrenValue => {
    const { value } = this.props;
    const valueToCheck =
      typeof value !== 'undefined' ? value : this.state.value;

    return valueToCheck === childrenValue;
  };

  render() {
    const radioButtons = [];
    const { children, className, disabled, id, options, style } = this.props;

    if (options.length === 0) {
      Children.forEach(children, (element, index) => {
        const { value } = element.props;

        radioButtons.push(
          cloneElement(element, {
            key: `radio-${index}`,
            onChange: this.handleChildrenChange,
            checked: this.childrenChecked(value),
            disabled
          })
        );
      });
    } else {
      options.forEach(option => {
        radioButtons.push(
          <React.Fragment key={option.value}>
            <RadioButton
              checked={this.childrenChecked(option.value)}
              disabled={disabled}
              id={option.value}
              onChange={this.handleChildrenChange}
              value={option.value}
            />
            <Label htmlFor={option.value} inline>
              {option.labelText}
            </Label>
          </React.Fragment>
        );
      });
    }

    return (
      <span style={style} className={className} id={id}>
        {radioButtons}
      </span>
    );
  }
}

RadioButtonGroup.propTypes = {
  value: string,
  style: shape({}),
  id: string,
  className: string,
  disabled: bool,
  autoFocus: bool,
  onChange: func,
  options: arrayOf(
    shape({
      value: string,
      labelText: string
    })
  )
};

RadioButtonGroup.defaultProps = {
  value: undefined,
  style: {},
  id: undefined,
  className: '',
  disabled: false,
  autoFocus: false,
  options: []
};
